export const MAX_INVITE_TO_JOB = 15;
export const MAX_ADD_TO_PIPELINE = 15;
